module.exports = "/build/web/svg/event/e-sport.e958f31ced3337f3a3ce96c381bcb98c.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/e-sport.svg
// module id = 156
// module chunks = 24